import { isEmpty, isNotDefined, type TeamData, type TeamId, type TeamLevel, type TeamUpdateData } from '@terros/common'

export type TeamLevelMoveContext = {
  team: TeamData
  parentLevel: TeamLevel | undefined
  highestChildLevel: TeamLevel | undefined
  highestTeamLevel: TeamLevel
}

type ToContextProps = {
  team: TeamData
  teams: TeamData[]
  highestTeamLevel: TeamLevel
}

export const toTeamLevelMoveContext = ({ team, teams, highestTeamLevel }: ToContextProps): TeamLevelMoveContext => {
  const parentLevel = teams.find((candidate) => candidate.teamId === team.parentId)?.level
  const childLevels = teams.filter((candidate) => candidate.parentId === team.teamId).map((child) => child.level)
  const highestChildLevel = isEmpty(childLevels) ? undefined : Math.max(...childLevels)
  return { team, parentLevel, highestChildLevel, highestTeamLevel }
}

export const canMoveTeamToLevel = (context: TeamLevelMoveContext, targetLevel: TeamLevel): boolean => {
  const { parentLevel, highestChildLevel, highestTeamLevel } = context
  if (targetLevel === highestTeamLevel) return true
  if (isNotDefined(parentLevel)) return false
  if (targetLevel >= parentLevel) return false
  if (targetLevel <= (highestChildLevel ?? 0)) return false
  return true
}

export const toTeamLevelUpdate = (context: TeamLevelMoveContext, level: TeamLevel): TeamUpdateData => {
  const { team, highestTeamLevel } = context
  const parentId: TeamId | null | undefined = level === highestTeamLevel ? null : team.parentId
  return { teamId: team.teamId, level, parentId }
}
